<h2 class="uk-modal-title">Get an instant quote now!</h2>
<p class="uk-text-small">
  Enter your phone number and email for an instant quote that will immediately
  appear below. You will also receive your personalized quote to the email
  provided.
</p>
